<template>
  <div>
    <div class="boxxuanfu">
      <div class="top3">
        <div class="topcer">
          <div class="image">
            <img :src="downBoxan.logo"
                 alt="">
          </div>
        </div>
      </div>
    </div>
    <img class="Backgroundpicture"
         src="../../static/images/appdown.png"
         alt="">
    <div class="QRcode">
      <div class="QRcodeleft">
        <div class="twoQRcode">
          <div class="QRcodeimg">
            <div id="qrcode"></div>
          </div>
          <div class="QRcodetext">
            <div class="QRcodetexttop">
              <div>官方</div>
              <div>正版</div>
              <div>无广告</div>
            </div>
            <div class="QRcodetextban">
              <span>版本：1.2.0</span>
              <!-- <span>系统：1.2.0</span> -->
            </div>
            <div class="QRcodetexttui">
              <div class="smaller">推荐 <span v-for="(item,index) in 5"
                      :key="index"><img src="../../static/images/实五角星.png"
                       alt=""></span></div>
            </div>
          </div>
        </div>
        <div class="downBtntwo">
          <div class="downBtn"
               @click="downBoxanmen(1)">
            <a :href="downBoxanurl"
               ref="metleft"
               :style="{'pointer-events' : morenstyle}">
              <div class="">安卓免费下载</div>
            </a>
          </div>
          <div class="downBtn"
               @click="downBoxanmen(2)">
            <a :href="downBoxpingurl"
               :style="{'pointer-events' : morenstyletwo}">
              <div class="">苹果免费下载</div>
            </a>
          </div>
        </div>
      </div>
      <div class="QRcoderight">
        <div class="QRcoderightimg"><img src="../../static/images/7.png"
               alt=""></div>
      </div>
    </div>
    <div class="welfaretext">
      <div class="welfaretextTop">上线享受4大福利</div>
      <div class="welfarecontent">
        <div class="welfarecontentdata"
             v-for="(item,index) in dataList"
             :key="index">
          <div class="welfarecontentdatatheader">{{item.titlel}}</div>
          <div class="welfarecontentdataTop">
            <div class="welfarecontentdatafont">{{item.title}}</div>
            <div class="welfarecontentdatafont">{{item.concer}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="goodthree">
      <div class="goodthreeright">
        <div class="goodthreetop">我们到底好在哪</div>
        <div class="vstext">
          <div class="vstextleft">
            <div class="wanyugame">{{downBoxan.title}}</div>
            <div class="wanyugametext">官服品质，变态玩法，火爆手游平台</div>
            <div class="wanyugametext">容纳市面热门H5手游</div>
            <div class="wanyugametext">官方授权，永久安全</div>
            <div class="wanyugametext">活动更新，返利游戏</div>
            <div class="wanyugametext">壕送礼包福利</div>
            <div class="wanyugametext">专业客服MM服务6*9小时跟踪</div>
          </div>
          <div class="va">vs</div>
          <div class="vstextright">
            <div class="wanyugame">其他渠道</div>
            <div class="wanyugametext">私人搭建，不稳定 违法 违规</div>
            <div class="wanyugametext">极少，甚至只有一两款</div>
            <div class="wanyugametext">随时关服</div>
            <div class="wanyugametext">根本没有活动</div>
            <div class="wanyugametext">没有福利</div>
            <div class="wanyugametext">客服？请自给自足</div>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both;"></div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  data () {
    return {
      siteData: '',
      versionData: '',
      tag: "yxhz1",
      downBoxan: 'javascript:void(0)',
      downBoxping: 'javascript:void(0)',
      morenstyle: "auto",
      morenstyletwo: "auto",
      logoOne: false,
      logoTwo: true,
      siteDataName: false,
      siteDataNametwo: true,
      system: "",
      downBoxanurl: "",
      downBoxpingurl: "",
      pinres: "",
      anres: "",
      dataList: [
        { "titlel": "礼包领取", "title": "享受海量金币活动礼包", "concer": "等福利领取" },
        { "titlel": "每日更新", "title": "每周更新3-5款热门手游", "concer": "火爆游戏一打尽" },
        { "titlel": "充值返利", "title": "返利服游戏5-10倍充值返利", "concer": "游戏内战力飙升" },
        { "titlel": "在线客服", "title": "专业客服团队在线服务", "concer": "游戏放心畅玩" }
      ]
    }
  },
  mounted () {
    //  安卓
    let formDatatwo = new FormData();
    formDatatwo.append("system", 1)
    formDatatwo.append("channel", this.$RouterDatac.c)
    this.$apiFun.boxDown(formDatatwo).then((res) => {
      if (res.status == 404) {
        this.morenstyle = "none"
        this.anres = res
      } else {
        this.downBoxanurl = res.data.url
        this.downBoxan = res.data
      }


    })
    //  苹果
    let formData = new FormData();
    formData.append("system", 2)
    formData.append("channel", this.$RouterDatac.c)
    this.$apiFun.boxDown(formData).then((res) => {
      if (res.status == 404) {
        this.morenstyletwo = "none"
        this.pinres = res
      } else {
        this.downBoxpingurl = res.data.url
        this.pinres = res
      }
    })
    new QRCode("qrcode", {
      width: 130, // 二维码宽度，单位像素
      height: 130, // 二维码高度，单位像素
      text: window.location.href,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    })
    document.documentElement.scrollTop = 0;

  },
  methods: {
    downBoxanmen (yusa) {
      if (yusa == 1) {
        if (this.anres.status == 404) {
          this.$message(this.anres.msg);
        } else {
          setTimeout(() => {
            this.morenstyle = "auto"
          }, 5000)
        }

      }
      if (yusa == 2) {
        if (this.pinres.status == 404) {
          this.$message(this.pinres.msg);
        } else {
          setTimeout(() => {
            this.morenstyletwo = "auto"
          }, 5000)
        }

      }
    },
  }
}
</script>

<style scoped>
.Backgroundpicture {
  width: 100%;
  height: 2746px;
  position: absolute;
  top: 0;
  z-index: -1;
}
.QRcode {
  width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 294px;
  color: #fff;
}
a {
  text-decoration: none !important;
  color: #000 !important;
}
a:hover {
  text-decoration: overline;
}
.twoQRcode {
  display: flex;
  justify-content: space-between;
  width: 450px;
  margin-top: 300px;
}
.QRcodetexttop {
  display: flex;
  margin-top: 10px;
}
.QRcodeleft {
  font-size: 18px;
  font-weight: 400;
  color: #000;
}
.QRcodetexttop div {
  width: 58px;
  height: 24px;
  margin-right: 30px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #000;
  text-align: center;
  line-height: 24px;
}
.QRcodetext {
  width: 300px;
}
.QRcodetextban,
.QRcodetexttui {
  margin-top: 20px;
}
.downBtn {
  width: 144px;
  height: 44px;
  line-height: 44px;
  border: 1px #000 solid;
  border-radius: 20px;
  text-align: center;
}
.downBtntwo {
  display: flex;
  justify-content: space-between;
  width: 350px;
  margin-top: 30px;
}
.welfaretext {
  width: 1000px;
  margin: 0 auto;
  color: #000;
  margin-top: 200px;
}
.QRcodeimg img {
  width: 123px;
  height: 123px;
}
.welfaretextTop {
  text-align: center;
  font-size: 32px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
}
.smaller {
  display: flex;
}
.smaller img {
  width: 20px;
  height: 20px;
}
.welfarecontentdatatheader {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.welfarecontent {
  display: flex;
  justify-content: space-between;
  margin-top: 150px;
}
.welfarecontentdata {
  width: 220px;
}
.welfarecontentdatafont {
  font-size: 18px;
  font-family: Source Han Sans CN-Light, Source Han Sans CN;
  font-weight: 300;
  text-align: center;
  line-height: 40px;
}
.welfarecontentdataTop {
  margin-top: 50px;
}
.goodthree {
  width: 1000px;
  margin: 0 auto;
  margin-top: 350px;
}
.goodthreeright {
  width: 650px;
  float: right;
  text-align: center;
  margin-bottom: 185px;
}
.goodthreetop {
  text-align: center;
  font-size: 32px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
}
.vstext {
  display: flex;
  justify-content: space-between;
}
.vstextleft {
  color: #f68b00;
}
.vstextright {
  color: #666666;
}
.wanyugame {
  font-size: 28px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  height: 160px;
  line-height: 160px;
}
.wanyugametext {
  font-size: 18px;
  font-family: Source Han Sans CN-Light, Source Han Sans CN;
  font-weight: 300;
  line-height: 50px;
}
.va {
  width: 100px;
  font-size: 54px;
  font-family: Segoe UI-Bold Italic, Segoe UI;
  font-weight: normal;
  color: #e60112;
  font-weight: 600;
  line-height: 0px;
  -webkit-text-stroke: 1px #ffbb00;
  text-stroke: 1px #ffbb00;
  margin-top: 75px;
}
#qrcode {
  width: 130px;
  height: 130px;
  position: absolute;
  z-index: 999;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/details/appDown/index.vue